import { render, staticRenderFns } from "./PackageMedicine.vue?vue&type=template&id=d2daebda&scoped=true"
import script from "./PackageMedicine.vue?vue&type=script&lang=js"
export * from "./PackageMedicine.vue?vue&type=script&lang=js"
import style0 from "./PackageMedicine.vue?vue&type=style&index=0&id=d2daebda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2daebda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2daebda')) {
      api.createRecord('d2daebda', component.options)
    } else {
      api.reload('d2daebda', component.options)
    }
    module.hot.accept("./PackageMedicine.vue?vue&type=template&id=d2daebda&scoped=true", function () {
      api.rerender('d2daebda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/PackageMedicine.vue"
export default component.exports